import { type ComponentProps } from 'react';

import { DisplayText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationModalHeading = (props: Props) => {
  const { children, ...restProps } = props;

  return (
    <DisplayText sizeMatch={['24', '32']} {...restProps}>
      {children}
    </DisplayText>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = ComponentProps<typeof DisplayText>;
